import { KLYDO_WHITE } from '../../../consts/colors';
import { DSTypography } from '../../../design-system/Typography';

/** Sign-in headline shown above the auth form — mobile uses a compact centered
 * variant, desktop uses the large variant. `desktopAlign` controls the desktop
 * text alignment: left-aligned by default, the regular auth page centers it. */
const Headline = ({
  mobile = false,
  desktopAlign = 'left',
}: {
  mobile?: boolean;
  desktopAlign?: 'left' | 'center';
}) =>
  mobile ? (
    <DSTypography
      variant="h5"
      sx={{
        fontFamily: 'Gilroy-Bold',
        color: KLYDO_WHITE,
        textAlign: 'center',
      }}
    >
      Make the art you
      <br />
      actually want to make
    </DSTypography>
  ) : (
    <DSTypography
      sx={{
        fontWeight: 800,
        lineHeight: 1.1,
        color: KLYDO_WHITE,
        fontSize: 'clamp(28px, 2.8vw, 44px)',
        textAlign: desktopAlign,
        whiteSpace: 'nowrap',
      }}
    >
      Make The Art You
      <br />
      Actually Want To Make
    </DSTypography>
  );

export default Headline;
